<!-- View Notification -->
<div class="page-header">
  <div class="header-content">
    <div class="header-main">
      <div class="header-icon">
        <i class="fas fa-envelope-open"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">{{ notification?.title || 'Notification' }}</h1>
        <p class="page-description">Notification details</p>
      </div>
    </div>
  </div>
</div>

<!-- Notification Content Card -->
<div class="data-panel">
  <div class="panel-header">
    <div class="panel-title">
      <div class="title-icon">
        <i class="fas fa-info-circle"></i>
      </div>
      <div class="title-content">
        <div class="title-text">{{ notification?.title }}</div>
      </div>
    </div>
  </div>

  <div class="panel-body" style="padding: 24px;">
    <div style="max-width: 680px;">
      <p style="font-size: 14px; color: var(--text-secondary); line-height: 1.7;">{{ notification?.title }}</p>
    </div>
  </div>
</div>
